import { Smartphone } from "lucide-react"
import { useState } from "react"

export default function SmsConsentCard() {
  const [consent, setConsent] = useState({
    informational: true,
    marketing: true,
    none: false,
  })

  const toggle = (key: keyof typeof consent) => {
    if (key === "none") {
      setConsent({
        informational: false,
        marketing: false,
        none: true,
      })
    } else {
      setConsent(prev => {
        const updated = {
          ...prev,
          [key]: !prev[key],
          none: false,
        }

        if (!updated.informational && !updated.marketing) {
          updated.none = true
        }

        return updated
      })
    }
  }

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-gradient-to-br from-gray-50 to-white dark:from-gray-900/50 dark:to-gray-900 p-6 space-y-6">
      {/* Header */}
      <div className="flex gap-4">
        <div className="rounded-lg bg-blue-50 dark:bg-blue-900/30 p-2.5 flex justify-center items-center">
          <Smartphone className="w-6 h-6 text-blue-600 dark:text-blue-400" />
        </div>
        <div>
          <h4 className="font-semibold text-lg text-gray-900 dark:text-white">
            SMS/Text Message Consent
          </h4>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Megenagna Bota LLC DBA Habesha Network would like your consent to send
            text message communications from <strong>+18555537873</strong> to your
            mobile number listed above, regarding account notifications,
            customer care, marketing.
          </p>
        </div>
      </div>

      {/* Disclosure */}
      <div className="text-xs text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-800/50 rounded-lg p-4 leading-relaxed">
        Consent is not a condition of purchase. Message frequency varies.
        Message and data rates may apply. Reply <strong>STOP</strong> to
        unsubscribe at any time. Reply <strong>HELP</strong> for assistance or
        more information.
      </div>

      {/* Consent Options */}
      <div className="space-y-4">
        {/* Informational */}
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={consent.informational}
            onChange={() => toggle("informational")}
            className="mt-1 w-4 h-4 rounded border-gray-300 dark:border-gray-600"
          />
          <span className="text-sm text-gray-800 dark:text-gray-200">
            Yes, I consent to receive informational messages from{" "}
            <strong>Megenagna Bota LLC DBA Habesha Network</strong> regarding
            account notifications, customer care, marketing.
          </span>
        </label>

        {/* Marketing */}
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={consent.marketing}
            onChange={() => toggle("marketing")}
            className="mt-1 w-4 h-4 rounded border-gray-300 dark:border-gray-600"
          />
          <span className="text-sm text-gray-800 dark:text-gray-200">
            Yes, I consent to receive marketing text messages from{" "}
            <strong>Megenagna Bota LLC DBA Habesha Network</strong>
          </span>
        </label>

        {/* No Consent */}
        <label className="flex items-start gap-3 cursor-pointer pt-2">
          <input
            type="checkbox"
            checked={consent.none}
            onChange={() => toggle("none")}
            className="mt-1 w-4 h-4 rounded border-gray-300 dark:border-gray-600"
          />
          <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
            No, I do not want to receive any text messages from{" "}
            <strong>Megenagna Bota LLC DBA Habesha Network</strong>
          </span>
        </label>
      </div>

      {/* Footer */}
      <div className="text-xs text-gray-500 dark:text-gray-400 border-t pt-4">
        We do not share your mobile opt-in information with anyone. See our{" "}
        <a
          href="/legal/privacy"
          className="text-blue-600 dark:text-blue-400 hover:underline font-medium"
        >
          Privacy Policy
        </a>{" "}
        for more information on how we handle your data.
      </div>
    </div>
  )
}